module.exports = __webpack_public_path__ + "static/img/takagi_03.0caf0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/takagi_03.png
// module id = VmHJ
// module chunks = 0